import { generateAvatarGraphics } from '@swf/poker';

export const USER_AVATARS_COLORS = [
  '#572DA5',
  '#15B799',
  '#74481E',
  '#F1B844',
  '#5A8DC5',
  '#7BB045',
  '#36809B',
  '#AC6FA7',
  '#D05A68',
  '#53AC66',
  '#AC7853',
  '#ACA253',
  '#87C5AB',
  '#47862D',
  '#931F74',
  '#D279C3',
  '#C5879B',
  '#8d2121',
  '#461874',
  '#235c2f',
  '#D23A2D',
  '#3a4f9d',
  '#b47a03'
];

export const getAvatarColor = (userId: string | undefined) => {
  if (!userId) {
    return '';
  }

  return generateAvatarGraphics(userId, USER_AVATARS_COLORS, 'color');
};
